import styled from "styled-components";

export const HeroContainer = styled.div`
  background-image: linear-gradient(
      to right,
      rgba(10, 57, 73, 0.5),
      rgba(0, 0, 0, 0.1) 40%
    ),
    url(https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80);
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: white;

  @media (min-width: 800px) {
    background-position: center center;
  }
`;

export const Row = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
`;

export const HeroText = styled.div`
  font-weight: bolder;
  h1 {
    font-size: 3rem;
  }

  .text-sm::after {
    content: "";
    display: inline-block;
    margin-left: 0.1em;
    background: white;
    width: 40px;
    height: 3px;
    vertical-align: middle;
    border-radius: 0.2em;
  }

  .text-sm {
    font-size: 2.8rem;
  }
  @media (min-width: 800px) {
    h1 {
      font-size: 5rem;
    }

    .text-sm {
      font-size: 4rem;
    }
  }
`;
